import { render, staticRenderFns } from "./UploadCoverScribe.vue?vue&type=template&id=349b5ee7&"
import script from "./UploadCoverScribe.vue?vue&type=script&lang=js&"
export * from "./UploadCoverScribe.vue?vue&type=script&lang=js&"
import style0 from "./UploadCoverScribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349b5ee7')) {
      api.createRecord('349b5ee7', component.options)
    } else {
      api.reload('349b5ee7', component.options)
    }
    module.hot.accept("./UploadCoverScribe.vue?vue&type=template&id=349b5ee7&", function () {
      api.rerender('349b5ee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadCoverScribe.vue"
export default component.exports